import { Request } from "./request";

//省数据分析-监管数据占比
export function getProvinceDataAnaylse(scope: number): Request {
  return {
    url: `/api/analysis/area/percentage`,
    method: "GET",
    params: {
      scope,
    },
  };
}

// 省数据分析 - 监管数据变化
export function getProvinceDataContrast(scope: number): Request {
  return {
    url: `/api/analysis/area/change`,
    method: "GET",
    params: {
      scope,
    },
  };
}

export function getProvinceAuthList(scope?: number): Request {
  return {
    url: `/api/analysis/area/index`,
    method: "GET",
    params: {
      scope,
    },
  };
}
